module.exports = __webpack_public_path__ + "img/secure.baf31800.svg";